import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Button } from '@qrios/frontend-library';
import { useTheme } from '@mui/material/styles';
import { Timelapse } from '@mui/icons-material';

import { HandleOpenCancelDialog } from '../../interfaces';
import locales from '../../../../../../constants/locales';
import { PendingReport, ReportMetadata } from '../../../interfaces';
import { formatDate, TABLE_DATE_TIME_FORMAT } from '../../../../../../constants/helpers/dates';

import DetailItem from '../detailItem';
import DetailsFactory from './detailsFactory';

interface Props {
  report: PendingReport;
  handleOpenCancelDialog: HandleOpenCancelDialog;
  handleCloseDetailsDialog: () => void;
  appliedFilters: (filters: ReportMetadata) => ReactNode;
}
const PendingDetails = ({ report, handleOpenCancelDialog, handleCloseDetailsDialog, appliedFilters }: Props) => {
  const theme = useTheme();

  return (
    <DetailsFactory
      action={{
        icon: { component: Timelapse, color: theme.palette.warning.main },
        text: report.progress !== undefined ? `Report generation in progress (${report.progress}%)...` : 'Report generation in progress...',
        content: (
          <Box width="100%" mt={2} mb={2}>
            <Button
              fullWidth
              onClick={() => {
                handleOpenCancelDialog(report);
                handleCloseDetailsDialog();
              }}
              text={locales.button.title.cancelReportGeneration}
              danger
              data-testid={`button-${locales.button.title.cancelReportGeneration}`}
            />
          </Box>
        )
      }}
      metaContent={<DetailItem label="Ordered date" value={formatDate(report.orderDate, TABLE_DATE_TIME_FORMAT)} />}
      filtersContent={<DetailItem label="Applied Filters" value={appliedFilters(report.metadata)} />}
    />
  );
};

export default PendingDetails;
